import { callApi } from "../helpers/Api";
import { isTruthy } from "../utils/helpers";
import pages from "../subscriber/Pages";

export const getBlogs = () => {
    const functionUrl = `blogs`;
    const isBackground = true;
    const method = "GET";

    try {
        callApi({ functionUrl, method, isBackground }).then((response) => {
            const { status, result } = response || {};
            if(isTruthy(status)) {
                pages.updateValue("blogs", result);
            }
        });
    } catch (error) {
        console.error("API error: ", error);
        return false;
    }
};

export const getBlog = (slug) => {
    const functionUrl = `blog`;
    const isBackground = true;
    const method = "GET";
    const urlValue = slug;

    try {
        return callApi({ functionUrl, method, isBackground, urlValue }).then((response) => {
            const { status, result } = response || {};
            if(isTruthy(status)) {
                return result;
            }
            return null;
        });
    } catch (error) {
        console.error("API error: ", error);
        return null;
    }
};

export const postComment = (requestBody = {}) => {
    const functionUrl = `post_comment`;
    const isBackground = true;

    try {
        return callApi({ functionUrl, requestBody, isBackground }).then((response) => {
            return response;
        });
    } catch (error) {
        console.error("API error: ", error);
        return false;
    }
};